import { headers } from "../utils/utils";

const useTipoBiografiaStore = defineStore("tipo_biografia", () => {
  // stados
  const tipo_biografia = ref({
    id: null,
    nombre: null,
    descripcion: "",
    tipo_redaccion: 1, // 1 => primera, 2 => segunda  y 3 => tercera persona
    cuestionarios: [],
    cuestionario: null,
    icono: null,
    publico: false,
  });

  const tipos = ref([]);

  // getters

  const draft = computed(() => clone(tipo_biografia.value));

  // mutations

  const clear = () => {
    tipo_biografia.value = {
      id: null,
      nombre: null,
      descripcion: "",
      tipo_redaccion: 1, // 1 => primera, 2 => segunda  y 3 => tercera persona
      cuestionarios: [],
      cuestionario: null,
      icono: null,
      publico: false,
    };
  };

  // actions

  const fetch = (tipo_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/tipo-biografias/${tipo_id}/fetch-data`)
        .then(({ data }) => {
          tipo_biografia.value = data;
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  const fetchData = (datos) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/tipo-biografias/fetch-data`, datos)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  const guardar = async (datos) => {
    let formData = new FormData();
    Object.keys(datos).forEach((key) => {
      if (key == "cuestionarios") {
        formData.append("cuestionarios[]", datos[key]);
      } else {
        formData.append(key, datos[key]);
      }
    });

    try {
      if (datos.id) {
        formData.append("_method", "PUT");

        const { data } = await axios.post(
          `/api/tipo-biografias/${datos.id}`,
          formData,
          { headers }
        );

        if (data.result) {
          tipo_biografia.value = data.tipo_biografia;
        }
        return data;
      } else {
        const { data } = await axios.post(`/api/tipo-biografias`, formData, {
          headers,
        });
        if (data.result) tipo_biografia.value = data.tipo_biografia;
        return data;
      }
    } catch (error) {
      throw error;
    }
  };

  const eliminar = (tipo_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/tipo-biografias/${tipo_id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchSelectList = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/tipo-biografias/select-list`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  return {
    // states
    tipo_biografia,
    tipos,
    // getters
    draft,
    // methods or actions
    fetch,
    fetchData,
    guardar,
    eliminar,
    clear,
    fetchSelectList,
  };
});

export default useTipoBiografiaStore;
